var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["default"]: () => __WEBPACK_EXTERNAL_MODULE_https_unpkg_com_bignumber_js_9_0_2_bignumber_mjs_7bd08215__["default"] });